module.exports = __webpack_public_path__ + "static/media/trainScreenshot.e39b58b3.png";